import { useState } from 'react';

function PageSizeDropdown(props) {
	const [value, setValue] = useState(props.pageSize);

	const onChange = evt => {
		setValue(evt.target.value);
		props.onChange(parseInt(evt.target.value));
	};

	return (<select value={value} onChange={onChange}>
		<option value="10">10</option>
		<option value="20">20</option>
		<option value="50">50</option>
	</select>);
}

export default PageSizeDropdown;
